import { get } from "lodash";
import {
  Case,
  DistributionList,
  CaseFollow,
  Relationship,
  User,
} from "typings";
import { reduce, find, some } from "lodash";

const findRelatedCase = (included: any[], relatedCase: Relationship) =>
  find(included, (related: Case | DistributionList) => {
    if (related && related.id && relatedCase && relatedCase.data) {
      return related.id === relatedCase.data.id;
    }
  });

const findRelatedDistributionList = (
  included: any[],
  relatedDistributionList: Relationship,
) =>
  find(included, (related: Case | DistributionList) => {
    if (
      related &&
      related.id &&
      relatedDistributionList &&
      relatedDistributionList.data
    ) {
      return related.id === relatedDistributionList.data.id;
    }
  });

export const mapCaseAndDistributionListToCaseFollows = (
  caseFollows: CaseFollow[],
  included: any[],
) =>
  reduce(
    caseFollows,
    (acc: any[], caseFollow) => {
      const relatedCase = findRelatedCase(
        included,
        caseFollow.relationships.case,
      );
      const relatedDistributionList = findRelatedDistributionList(
        included,
        caseFollow.relationships.distributionList,
      );
      if (relatedCase && relatedDistributionList) {
        acc.push({
          caseFollowId: caseFollow.id,
          distributionListId: relatedDistributionList.id,
          caseId: relatedCase.id,
          ...caseFollow.attributes,
          ...relatedDistributionList.attributes,
          ...relatedCase.attributes,
        });
      }
      return acc;
    },
    [],
  );

export const mapCaseToDistributionLists = (
  distributionLists?: DistributionList[],
  included?: any[],
) =>
  reduce(
    distributionLists,
    (acc: any[], distributionList) => {
      const relatedCase = findRelatedCase(
        included!,
        distributionList.relationships.case,
      );
      if (relatedCase) {
        acc.push({
          distributionListId: distributionList.id,
          caseId: relatedCase.id,
          members: distributionList.relationships.members,
          ...distributionList.attributes,
          ...relatedCase.attributes,
        });
      }
      return acc;
    },
    [],
  );

export const mapCaseAndUsersToDistributionList = (
  distributionList: DistributionList,
  included: any[] = [],
) => {
  const relatedCase = findRelatedCase(
    included,
    distributionList.relationships.case,
  );
  const relatedCaseFollows = included!.filter(
    related =>
      distributionList &&
      related.type === "caseFollows" &&
      related.relationships.distributionList.data &&
      related.relationships.distributionList.data.id === distributionList.id,
  );
  const relatedUsers = included!
    .filter(related => related.type === "users")
    .map(user => {
      const userCaseFollow = find(relatedCaseFollows, caseFollow =>
        some(
          user.relationships.caseFollows.data,
          (userCaseFollow: { type: string; id: string }) =>
            userCaseFollow.id === caseFollow.id,
        ),
      );
      return {
        userId: user.id,
        ...user.attributes,
        caseFollow: {
          caseFollowId: userCaseFollow.id,
          ...userCaseFollow.attributes,
        },
      };
    });
  if (distributionList && relatedCase && relatedUsers) {
    return {
      distributionListId: distributionList.id,
      caseId: relatedCase.id,
      users: relatedUsers,
      ...distributionList.attributes,
      ...relatedCase.attributes,
    };
  }
};

export const relateUserToCaseFollow = (
  caseFollow: CaseFollow,
  users: User[],
) => {
  const userId = get(caseFollow.relationships.user, "data.id");
  return users.find(user => user.id === userId);
};
